import { FC } from 'react';
import { Flex, Box } from '@rebass/emotion';
import { FormattedMessage } from 'react-intl';

import { H1 } from '@app/shop/components/typography';
import { CheckoutSuccessQuery_magento2_customer } from '@app/shop/pages/Checkout/Success/__generated__/CheckoutSuccessQuery';

import messages from './Success.messages';
import successIcon from './assets/success.svg';

const OrderStatus: FC<{
  customer?: CheckoutSuccessQuery_magento2_customer;
}> = ({ customer }) => (
  <>
    <H1>
      <FormattedMessage
        {...messages.thankYouTitle}
        values={{ name: customer?.firstname }}
      />
    </H1>
    <Flex>
      <Box mt={20} mr={15}>
        <img src={successIcon} alt="" css={{ maxWidth: 'unset' }} />
      </Box>
      <Flex mt={20} mb={0} flexWrap="wrap" justifyContent="flex-start">
        <Box width={1} mb="0.5rem">
          <FormattedMessage {...messages.successMessage} />
        </Box>

        <Box width={1} mb={10}>
          <FormattedMessage
            {...messages.successEmail}
            values={{ email: customer?.email }}
          />
        </Box>
      </Flex>
    </Flex>
  </>
);

export default OrderStatus;
